import { types } from "mobx-state-tree";

export const ExUser = types.model("ExUser", {
	id: types.identifier,
	_r: types.string,
	p: types.model({}),
});

export type IExUserModel = typeof ExUser.Type;
